const errorCallback = (e, callbacks) => {
  if (e.response || e.request) {
    const error = 'An error occurred while processing your request';
    callbacks.onServiceErrorCallback(error);
  } else {
    throw e;
  }
};

const callApi = async (callApiOptions) => {
  const {
    apiCall,
    callbacks,
    payload,
    form,
    formElement,
  } = callApiOptions;

  const API_CALL_BLOCKER = Symbol('API_CALL');

  formElement.addLoader(API_CALL_BLOCKER);
  form.addTransactionalBlocker(API_CALL_BLOCKER);

  let response = false;

  callbacks.onServiceCallback();
  try {
    const rawResponse = await apiCall(payload);
    response = rawResponse.data;
  } catch (e) {
    errorCallback(e, callbacks);
  }

  form.releaseTransactionalBlocker(API_CALL_BLOCKER);
  formElement.releaseLoader(API_CALL_BLOCKER);

  return response;
};

export default callApi;
